var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat3Line = function SvgChat3Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.762 19.942 3 21l1.058-4.762A9 9 0 0 1 12 3a9 9 0 0 1 9 9 9 9 0 0 1-13.238 7.942m.26-1.902.589.315A7.16 7.16 0 0 0 12 19.2a7.2 7.2 0 1 0-6.354-3.81l.314.587-.59 2.652z"
  })));
};
export default SvgChat3Line;